const defaultBlockName = {
  ID_OOBC_GENERAL_CONFIRM: "Confirm",
  ID_OOBC_GENERAL_CANCEL: "Cancel",
  ID_OOBC_GENERAL_DELETE: "Delete",
  ID_OOBC_GENERAL_CLEAR: "Clear",
  ID_OOBC_GENERAL_REPLACE: "Switch",
  ID_OOBC_GENERAL_CLOSE: "Close",

  ID_OOBC_BLOCK_STRING_DEFAULT: "text",
  ID_OOBC_BLOCK_NUMBER_DEFAULT: "number",

  ID_OOBC_BLOCK_ACTION_SET: "=",
  ID_OOBC_BLOCK_ACTION_MOVE: "Move",
  ID_OOBC_BLOCK_ACTION_MOVETO: "MoveTo",
  ID_OOBC_BLOCK_ACTION_GO: "Go",
  ID_OOBC_BLOCK_ACTION_GOTO: "GoTo",
  ID_OOBC_BLOCK_ACTION_ROTATE: "Rotate",
  ID_OOBC_BLOCK_ACTION_TURN: "Turn",
  ID_OOBC_BLOCK_ACTION_TURNTO: "TurnTo",
  ID_OOBC_BLOCK_ACTION_ADDSIZE: "AddSize",
  ID_OOBC_BLOCK_ACTION_PLAYANIMATION: "Animate",
  ID_OOBC_BLOCK_ACTION_STOPANIMATION: "StopAnimate",
  ID_OOBC_BLOCK_ACTION_SHOW: "Show",
  ID_OOBC_BLOCK_ACTION_HIDE: "Hide",
  ID_OOBC_BLOCK_ACTION_WAIT: "Wait",
  ID_OOBC_BLOCK_ACTION_SETCOLLISION: "Collide",
  ID_OOBC_BLOCK_ACTION_ONTOUCH: "Touch",
  ID_OOBC_BLOCK_ACTION_ONTOUCHUP: "TouchUp",
  ID_OOBC_BLOCK_ACTION_ONOUT: "Out",
  ID_OOBC_BLOCK_ACTION_ONCOLLIDE: "Collide",
  ID_OOBC_BLOCK_ACTION_ONCOLLIDEONCE: "CollideOnce",
  ID_OOBC_BLOCK_ACTION_ONCOLLIDEEND: "CollideEnd",
  ID_OOBC_BLOCK_ACTION_ONCONTACT: "Contact",
  ID_OOBC_BLOCK_ACTION_ONOVERLAP: "Overlap",
  ID_OOBC_BLOCK_ACTION_ONOVERLAPONCE: "OverlapOnce",
  ID_OOBC_BLOCK_ACTION_ONKEY: "KeyDown",
  ID_OOBC_BLOCK_ACTION_ONKEYUP: "KeyUp",
  ID_OOBC_BLOCK_ACTION_SAY: "Say",
  ID_OOBC_BLOCK_ACTION_SHAKE: "Shake",
  ID_OOBC_BLOCK_ACTION_FLASH: "Flash",
  ID_OOBC_BLOCK_ACTION_CHANGESCENE: "Change",
  ID_OOBC_BLOCK_ACTION_ONFRAME: "Frame",
  ID_OOBC_BLOCK_ACTION_ONSWIPE: "Swipe",
  ID_OOBC_BLOCK_ACTION_VIBRATE: "Vibrate",
  ID_OOBC_BLOCK_ACTION_SPEAK: "Speak",
  ID_OOBC_BLOCK_ACTION_ONSHAKE: "Shake",
  ID_OOBC_BLOCK_ACTION_BIND: "Bind",
  ID_OOBC_BLOCK_ACTION_PLAY: "Play",
  ID_OOBC_BLOCK_ACTION_RESTART: "Restart",
  ID_OOBC_BLOCK_ACTION_RESUME: "Resume",
  ID_OOBC_BLOCK_ACTION_STOP: "Stop",
  ID_OOBC_BLOCK_ACTION_PAUSE: "Pause",
  ID_OOBC_BLOCK_ACTION_KILL: "Kill",
  ID_OOBC_BLOCK_ACTION_SPAWN: "Spawn",
  ID_OOBC_BLOCK_ACTION_REVIVE: "Revive",
  ID_OOBC_BLOCK_ACTION_SETTEXT: "SetText",
  ID_OOBC_BLOCK_ACTION_SENDSIGNAL: "Signal",
  ID_OOBC_BLOCK_ACTION_ONSIGNAL: "OnSignal",
  ID_OOBC_BLOCK_ACTION_SHOWRANKING: "ShowDESC",
  ID_OOBC_BLOCK_ACTION_SHOWRANKINGASCENDING: "ShowASC",
  ID_OOBC_BLOCK_ACTION_SAVESCORE: "SaveScore",
  ID_OOBC_BLOCK_ACTION_STARTTIMER: "Start",
  ID_OOBC_BLOCK_ACTION_PAUSETIMER: "Pause",
  ID_OOBC_BLOCK_ACTION_RESUMETIMER: "Resume",
  ID_OOBC_BLOCK_ACTION_RESETTIMER: "Reset",
  // EVENT
  ID_OOBC_BLOCK_ACTION_ONCLICK: "Click",
  // PLAYER
  ID_OOBC_BLOCK_ACTION_CHANGEPLAYERSPEED: "ChangeSpeed",

  ID_OOBC_BLOCK_PROPERTY_TEXT: "text",
  ID_OOBC_BLOCK_PROPERTY_X: "x",
  ID_OOBC_BLOCK_PROPERTY_Y: "y",
  ID_OOBC_BLOCK_PROPERTY_WIDTH: "width",
  ID_OOBC_BLOCK_PROPERTY_HEIGHT: "height",
  ID_OOBC_BLOCK_PROPERTY_SIZE: "scale",
  ID_OOBC_BLOCK_PROPERTY_SCALE: "scale",
  ID_OOBC_BLOCK_PROPERTY_DEGREE: "degree",
  ID_OOBC_BLOCK_PROPERTY_MASS: "mass",
  ID_OOBC_BLOCK_PROPERTY_MOVESPEED: "moveSpeed",
  ID_OOBC_BLOCK_PROPERTY_DRAGGABLE: "draggable",
  ID_OOBC_BLOCK_PROPERTY_MOVABLE: "movable",
  ID_OOBC_BLOCK_PROPERTY_FLIPX: "flipX",
  ID_OOBC_BLOCK_PROPERTY_FLIPY: "flipY",
  ID_OOBC_BLOCK_PROPERTY_VELOCITYX: "velocityX",
  ID_OOBC_BLOCK_PROPERTY_VELOCITYY: "velocityY",
  ID_OOBC_BLOCK_PROPERTY_VELOCITYZ: "velocityZ",
  ID_OOBC_BLOCK_PROPERTY_GRAVITYX: "gravityX",
  ID_OOBC_BLOCK_PROPERTY_GRAVITYY: "gravityY",
  ID_OOBC_BLOCK_PROPERTY_BOUNCEX: "bounceX",
  ID_OOBC_BLOCK_PROPERTY_BOUNCEY: "bounceY",
  ID_OOBC_BLOCK_PROPERTY_ACCELERATIONX: "accelerationX",
  ID_OOBC_BLOCK_PROPERTY_ACCELERATIONY: "accelerationY",

  ID_OOBC_BLOCK_CONSTANT_RANDOM: "random",
  ID_OOBC_BLOCK_CONSTANT_TOUCH: "touch",
  ID_OOBC_BLOCK_CONSTANT_TIME: "time",

  ID_OOBC_BLOCK_CATEGORY_GAMEOBJECT: "Sprite",
  ID_OOBC_BLOCK_CATEGORY_PROPERTY: "Property",
  ID_OOBC_BLOCK_CATEGORY_ACTION: "Action",
  ID_OOBC_BLOCK_CATEGORY_GLOBALACTION: "Action",
  ID_OOBC_BLOCK_CATEGORY_FUNCTION: "Function",
  ID_OOBC_BLOCK_CATEGORY_CALLBACK: "Callback",
  ID_OOBC_BLOCK_CATEGORY_VARIABLE: "Variable",
  ID_OOBC_BLOCK_CATEGORY_CONSTANT: "Constant",
  ID_OOBC_BLOCK_CATEGORY_OPERATOR: "Operator",
  ID_OOBC_BLOCK_CATEGORY_UTIL: "Util",
  ID_OOBC_BLOCK_CATEGORY_CLOSE: "닫기",

  ID_OOBC_CONTEXTMENU_DELETE: "Delete",
  ID_OOBC_CONTEXTMENU_COPY: "Copy",
  ID_OOBC_CONTEXTMENU_PASTE: "Paste",
  ID_OOBC_CONTEXTMENU_ADD: "Add",
  ID_OOBC_CONTEXTMENU_DISABLE: "Deactivate",
  ID_OOBC_CONTEXTMENU_ENABLE: "Activate",
  ID_OOBC_CONTEXTMENU_COMMENT: "Comment",
  ID_OOBC_CONTEXTMENU_DELETECOMMENT: "Delete Comment",

  ID_OOBC_ALERT_ADDVAR_TITLE: "Add Variable",
  ID_OOBC_ALERT_ADDVAR_MESSAGE: "*Only alphabet&number allowed.\n*First letter must be alphabet.",
  ID_OOBC_ALERT_ADDVAR_PLACEHOLDER: "Enter Variable Name",
  ID_OOBC_ALERT_ADDVAR_INVALIDNAME_MESSAGE: "Check variable naming rule again.",
  ID_OOBC_ALERT_ADDVAR_EXISTNAME_MESSAGE: "Already exist with that name",
  ID_OOBC_ALERT_DISABLED_BLOCK_TITLE: "Inavailable block",
  ID_OOBC_ALERT_DISABLED_BLOCK_MESSAGE: "This block is inavailable for there",
  ID_OOBC_ALERT_DISABLED_ANIMATEBLOCK_MESSAGE: "Sprite with no animation\ncannot use animate blocks",
  ID_OOBC_ALERT_DELETELINE_TITLE: "Delete line",
  ID_OOBC_ALERT_DELETELINE_MESSAGE: "You cannot restore your line.\nStill want to delete?",
  ID_OOBC_ALERT_REPLACE_BLOCK_TITLE: "Block Replacement",
  ID_OOBC_ALERT_REPLACE_BLOCK_MESSAGE: "The following blocks will be removed.\nStill want to switch blocks?",

  ID_OOBC_CONSTANTEDITOR_KEY_MESSAGE: "Press any key.",
};

export default defaultBlockName;
